export default __webpack_public_path__ + "static/supabase_logo-920d89297fb98607abc5fb9dc6e6f9f6.svg";